import { ShipmentTrackingRecordsActionTypes } from './constants';

const INIT_STATE = {
    processingTrackingRecords: false,
    processTrackingRecordsResult: null,
    error: null,
};

type ShipmentTrackingRecordsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    processingTrackingRecords: Boolean,
    processTrackingRecordsResult: any,
    error: any,
};

const ShipmentTrackingRecords = (state: State = INIT_STATE, action: ShipmentTrackingRecordsAction): any => {
    switch (action.type) {
        case ShipmentTrackingRecordsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS: {
                    return {
                        ...state,
                        processingTrackingRecords: false,
                        processTrackingRecordsResult: action.payload.data,
                        error: null,
                    };
                }
                default:
                    return { ...state, processingTrackingRecords: false, error: null };
            }
        case ShipmentTrackingRecordsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS: {
                    return { ...state, processingTrackingRecords: false, error: action.payload.error };
                }
                default:
                    return { ...state, processingTrackingRecords: false };
            }
        case ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS:
            return { ...state, processingTrackingRecords: true, processTrackingRecordsResult: null };
        case ShipmentTrackingRecordsActionTypes.RESET_STATE:
            return INIT_STATE;
        default:
            return { ...state };
    }
};

export default ShipmentTrackingRecords;
